import React from 'react'

export default function footer() {
  return (
    <footer>
        Все права защищены &copy;
    </footer>
  )
}
